/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  if (n === 1) return 1;
  return 5;
}
export default ["sq-MK", [["p.d.", "m.d."], u, ["e paradites", "e pasdites"]], [["p.d.", "m.d."], u, ["paradite", "pasdite"]], [["d", "h", "m", "m", "e", "p", "sh"], ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"], ["e diel", "e hënë", "e martë", "e mërkurë", "e enjte", "e premte", "e shtunë"], ["die", "hën", "mar", "mër", "enj", "pre", "sht"]], [["d", "h", "m", "m", "e", "p", "sh"], ["die", "hën", "mar", "mër", "enj", "pre", "sht"], ["e diel", "e hënë", "e martë", "e mërkurë", "e enjte", "e premte", "e shtunë"], ["die", "hën", "mar", "mër", "enj", "pre", "sht"]], [["j", "sh", "m", "p", "m", "q", "k", "g", "sh", "t", "n", "dh"], ["jan", "shk", "mar", "pri", "maj", "qer", "korr", "gush", "sht", "tet", "nën", "dhj"], ["janar", "shkurt", "mars", "prill", "maj", "qershor", "korrik", "gusht", "shtator", "tetor", "nëntor", "dhjetor"]], u, [["p.K.", "mb.K."], u, ["para Krishtit", "mbas Krishtit"]], 1, [6, 0], ["d.M.yy", "d MMM y", "d MMMM y", "EEEE, d MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1}, {0}", u, "{1} 'në' {0}", u], [",", " ", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "#,##0.00 ¤", "#E0"], "MKD", "den", "Denari maqedonas", {
  "AFN": [],
  "ALL": ["Lekë"],
  "AMD": [],
  "AOA": [],
  "ARS": [],
  "AUD": ["A$", "AUD"],
  "AZN": [],
  "BAM": [],
  "BBD": [],
  "BDT": [],
  "BMD": [],
  "BND": [],
  "BOB": [],
  "BRL": [],
  "BSD": [],
  "BWP": [],
  "BZD": [],
  "CAD": ["CA$", "CAD"],
  "CLP": [],
  "CNY": ["CN¥", "CNY"],
  "COP": [],
  "CRC": [],
  "CUC": [],
  "CUP": [],
  "CZK": [],
  "DKK": [],
  "DOP": [],
  "EGP": [],
  "FJD": [],
  "FKP": [],
  "GBP": ["£", "GBP"],
  "GEL": [],
  "GIP": [],
  "GNF": [],
  "GTQ": [],
  "GYD": [],
  "HKD": ["HK$", "HKS"],
  "HNL": [],
  "HRK": [],
  "HUF": [],
  "IDR": [],
  "ILS": ["₪", "ILS"],
  "INR": ["₹", "INR"],
  "ISK": [],
  "JMD": [],
  "JPY": ["JP¥", "JPY"],
  "KHR": [],
  "KMF": [],
  "KPW": [],
  "KRW": ["₩", "KRW"],
  "KYD": [],
  "KZT": [],
  "LAK": [],
  "LBP": [],
  "LKR": [],
  "LRD": [],
  "MGA": [],
  "MKD": ["den"],
  "MMK": [],
  "MNT": [],
  "MUR": [],
  "MXN": ["MX$", "MXN"],
  "MYR": [],
  "NAD": [],
  "NGN": [],
  "NIO": [],
  "NOK": [],
  "NPR": [],
  "NZD": ["NZ$", "NZD"],
  "PHP": [],
  "PKR": [],
  "PLN": [],
  "PYG": [],
  "RON": [],
  "RUB": [],
  "RWF": [],
  "SBD": [],
  "SEK": [],
  "SGD": [],
  "SHP": [],
  "SRD": [],
  "SSP": [],
  "STN": [],
  "SYP": [],
  "THB": ["฿", "THB"],
  "TOP": [],
  "TRY": [],
  "TTD": [],
  "TWD": ["NT$", "TWD"],
  "UAH": [],
  "USD": ["US$", "USD"],
  "UYU": [],
  "VND": ["₫", "VND"],
  "XCD": ["EC$", "XCD"],
  "ZAR": [],
  "ZMW": []
}, "ltr", plural];
